import React from 'react';
import { accent, darkPurple } from '../utils/colors';

const SearchHeader = ({ 
  search, 
  setSearch, 
  searchInputRef, 
  setSearchDropdown, 
  searchDropdown,
  children // Для отображения результатов поиска
}) => {
  const [isMouseOverResults, setIsMouseOverResults] = React.useState(false);

  return (
    <div style={{
      width: '100%',
      background: 'linear-gradient(90deg, #a259f7 0%, #6a1b9a 100%)',
      color: '#fff',
      fontSize: 32,
      fontWeight: 800,
      letterSpacing: 1,
      padding: '32px 0 0 0',
      textAlign: 'center',
      boxShadow: '0 4px 24px #a259f733',
      marginBottom: 0,
      textShadow: '0 2px 12px #6a1b9a44',
      position: 'relative',
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
        <span>Навыки сотрудников</span>
        <div style={{ position: 'relative', width: 360, maxWidth: '90vw' }}>
          <input
            ref={searchInputRef}
            value={search}
            onChange={e => setSearch(e.target.value)}
            onFocus={() => {
              console.log('SearchHeader: Фокус на поле поиска, search:', search);
              if (search) setSearchDropdown(true);
            }}
            onBlur={() => {
              console.log('SearchHeader: Потеря фокуса поля поиска, isMouseOverResults:', isMouseOverResults);
              // Не закрываем dropdown, если мышь над результатами
              if (!isMouseOverResults) {
                setTimeout(() => {
                  console.log('SearchHeader: Закрываем dropdown после потери фокуса');
                  setSearchDropdown(false);
                }, 500); // Увеличиваем задержку
              } else {
                console.log('SearchHeader: Не закрываем dropdown - мышь над результатами');
              }
            }}
            placeholder="Поиск по навыкам..."
            style={{
              width: '100%',
              padding: '10px 16px 10px 38px',
              borderRadius: 10,
              border: `1.5px solid ${accent}`,
              fontSize: 16,
              outline: 'none',
              background: '#f7f3ff',
              color: darkPurple,
              fontWeight: 500,
              boxShadow: '0 2px 8px #a259f711',
              height: 40,
              boxSizing: 'border-box',
            }}
          />
          <span style={{ 
            position: 'absolute', 
            left: 12, 
            top: '50%', 
            transform: 'translateY(-50%)', 
            color: accent, 
            fontSize: 18, 
            pointerEvents: 'none', 
            display: 'flex', 
            alignItems: 'center', 
            height: 40 
          }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8"/>
              <line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
          </span>
        </div>
        {/* Отображение результатов поиска */}
        {children && React.cloneElement(children, {
          onMouseEnter: () => {
            console.log('SearchHeader: Мышь над результатами поиска');
            setIsMouseOverResults(true);
          },
          onMouseLeave: () => {
            console.log('SearchHeader: Мышь покинула результаты поиска');
            setIsMouseOverResults(false);
          }
        })}
      </div>
    </div>
  );
};

export default SearchHeader; 